import React, { ReactNode } from 'react'
import Typography from '../../Typography'

interface IBodyProps {
  children: ReactNode
}

function Body(props: IBodyProps) {
  const { children } = props
  return (
    <Typography variant="caption" size="l">
      {children}
    </Typography>
  )
}

Body.displayName = 'MessageBox.Body'

export { Body }
